import type {
	CoursesOverallLeaderboardQueryDto,
	CoursesSubmitChallengeResponseDto,
} from '@sportspredict/shared';
import type { Wire } from '../../types/common.types';
import { coursesApi } from './courses-base.api';
import type {
	ListChallengesOutput,
	GetChallengeInput,
	GetChallengeOutput,
	SubmitResponseInput,
	SubmitResponseOutput,
	GetOverallLeaderboardInput,
	GetOverallLeaderboardOutput,
} from '../../types/challenges.types';

const TAG = 'courses:challenges' as const;
// A prediction also changes the profile's "challenges joined" / streak stats.
const INVALIDATES = [TAG, 'courses:dashboard', 'courses:courses'] as const;

export const challengesEndpoints = coursesApi.injectEndpoints({
	endpoints: (builder) => ({
		listChallenges: builder.query<ListChallengesOutput, void>({
			query: () => ({ url: 'courses/challenges' }),
			providesTags: [TAG],
		}),
		getChallenge: builder.query<GetChallengeOutput, GetChallengeInput>({
			query: ({ challengeId }) => ({
				url: `courses/challenges/${encodeURIComponent(challengeId)}`,
			}),
			providesTags: [TAG],
		}),
		submitResponse: builder.mutation<SubmitResponseOutput, SubmitResponseInput>({
			query: (body) => ({
				url: 'courses/challenges/responses',
				method: 'POST',
				body: body satisfies Wire<CoursesSubmitChallengeResponseDto>,
			}),
			invalidatesTags: [...INVALIDATES],
		}),
		getOverallLeaderboard: builder.query<GetOverallLeaderboardOutput, GetOverallLeaderboardInput>({
			query: (params) => ({
				url: 'courses/leaderboard',
				params: params satisfies Wire<CoursesOverallLeaderboardQueryDto> | undefined,
			}),
			providesTags: [TAG],
		}),
	}),
});

export const {
	useListChallengesQuery,
	useLazyListChallengesQuery,
	useGetChallengeQuery,
	useLazyGetChallengeQuery,
	useSubmitResponseMutation,
	useGetOverallLeaderboardQuery,
	useLazyGetOverallLeaderboardQuery,
} = challengesEndpoints;
